import { useEffect, useState } from "react";
import { Switch } from "./ui/switch";
import { Label } from "./ui/label";
import FeedbackAccordion from "./FeedbackAccordion";
import { useAppContext } from "@/appContext";
import { getScore } from "@/utils/utils";
import GoodStar from "../../TDD-Images/good-star.png";
import BadStar from "../../TDD-Images/bad-star.png";

const Feedback = () => {
  const [expanded, setExpanded] = useState<boolean | undefined>(undefined);
  const [clickFlag, setClickFlag] = useState(false);
  const [score, setscore] = useState<number>(0);
  const { state } = useAppContext();
  const { feedbackContext } = state;

  const handleExpandSwitch = () => {
    setExpanded((ex) => !ex);
    setClickFlag(false);
  };

  useEffect(() => {
    setscore( getScore(feedbackContext));
  }, [feedbackContext]);


  return (
    <div className="flex h-[100vh] flex-col py-[30px] px-[24px] font-semibold text-[24px] gap-3 overflow-auto">
      <div className="flex justify-between items-center w-full p-0 m-0">
        <h6 className="p-0 m-0 text-[24px] font-semibold">
          Score:{" "}
          <span className={feedbackContext.length == 0 || score <= 10 ? "text-[#B42318]" : score <= 50 ? "text-[#B54708]": score <= 85 ? "text-[#027A48]": "text-[#027A48]"}>{feedbackContext.length == 0? 0 : score}</span>
        </h6>
        <div className="flex justify-center items-center">
                <img
                  src={score >= 10  ? GoodStar : BadStar}
                  alt="star"
                  className="w-[27px] object-contain"
                />
                <img
                  src={score >= 55 ? GoodStar : BadStar}
                  alt="star"
                  className="w-[27px] object-contain"
                />
                <img
                  src={score >= 75 ? GoodStar : BadStar}
                  alt="star"
                  className="w-[27px] object-contain"
                />
        </div>
        <div className="flex justify-center items-center gap-2 p-0 m-0">
          <Switch
            className="data-[state=checked]:bg-[#717BBC]"
            checked={expanded}
            onCheckedChange={handleExpandSwitch}
          />
          <Label className="p-0 m-0">Expand all</Label>
        </div>
      </div>
      <div>
        <FeedbackAccordion
          feedback={feedbackContext}
          isExpanded={expanded}
          setIsExpanded={setExpanded}
          clickFlag={clickFlag}
          setClickFlag={setClickFlag}
        />
      </div>
    </div>
  );
};

export default Feedback;
